import { RegistryType } from 'components/Shared/Markdown';
import { PopularCategories } from './popularCategories';
import { Categories } from './categories';
import { CategoryCollection } from './CategoryCollection';
import { SectionOverviews } from 'views/ContentPage/components/themes/BGH/sectionOverviews';
import { Ads } from './ads';
import { Editorials } from './editorials';
import { LatestProducts } from './latestProducts';
import { PopularBrands } from './popularBrands';
import { SeoSection } from './seo';
import { FaqContainer } from './FaqContainer';
import { CountdownContainer } from './countdownContainer';
import { ProductGuideContainer } from './productGuideContainer';
import { Benefits } from './benefits';
import { TopSellersInCategory } from './topSellersInCategory';

const PREFIX = 'Bygghemma.Commerce.Web.src.views.ContentPage.components';

export const registry = {
  [`${PREFIX}.AdBlock`]: Ads,
  [`${PREFIX}.LatestProductsBlock`]: LatestProducts,
  [`${PREFIX}.ProductGuideBlock`]: ProductGuideContainer,
  [`${PREFIX}.CategoriesBlock`]: Categories,
  [`${PREFIX}.PopularCategoriesBlock`]: PopularCategories,
  [`${PREFIX}.OurSectionsBlock`]: SectionOverviews,
  [`${PREFIX}.EditorialsBlock`]: Editorials,
  [`${PREFIX}.PopularBrandsBlock`]: PopularBrands,
  [`${PREFIX}.CategoryCollectionBlock`]: CategoryCollection,
  [`${PREFIX}.SeoBlock`]: SeoSection,
  [`${PREFIX}.FaqBlock`]: FaqContainer,
  [`${PREFIX}.CountdownBlock`]: CountdownContainer,
  [`${PREFIX}.BenefitsBlock`]: Benefits,
  [`${PREFIX}.TopSellersInCategoryBlock`]: TopSellersInCategory
} as RegistryType;
